import Button from '@jetbrains/ring-ui/components/button/button'
import ButtonToolbar from '@jetbrains/ring-ui/components/button-toolbar/button-toolbar'
import {H2} from '@jetbrains/ring-ui/components/heading/heading'
import {memo, useCallback} from 'react'

import type {BuildId} from '../../../../../types'
import BuildPathAndStatus from '../../../BuildPathAndStatus/BuildPathAndStatus'

import styles from './ArtifactChangeDetailsPopupHeader.css'

type Props = {
  className?: string
  currentBuildId: BuildId
  buildIds: ReadonlyArray<BuildId>
  onChangeCurrentBuildId: (arg0: BuildId) => unknown
}

function ArtifactChangeDetailsPopupHeader({
  className,
  currentBuildId,
  buildIds,
  onChangeCurrentBuildId,
}: Props) {
  const currentBuildIdPosition = buildIds.indexOf(currentBuildId)

  const onClickPreviousBuild = useCallback(() => {
    if (currentBuildIdPosition > 0) {
      onChangeCurrentBuildId(buildIds[currentBuildIdPosition - 1])
    }
  }, [currentBuildIdPosition, buildIds, onChangeCurrentBuildId])

  const onClickNextBuild = useCallback(() => {
    if (currentBuildIdPosition < buildIds.length - 1) {
      onChangeCurrentBuildId(buildIds[currentBuildIdPosition + 1])
    }
  }, [currentBuildIdPosition, buildIds, onChangeCurrentBuildId])

  return (
    <div className={className}>
      <div className={styles.header}>
        <H2 className={styles.title}>{`${currentBuildIdPosition + 1} of ${
          buildIds.length
        } Artifact Dependency Changes`}</H2>
        {buildIds.length > 1 && (
          <div>
            <ButtonToolbar>
              <Button onClick={onClickPreviousBuild} disabled={currentBuildIdPosition === 0}>
                {'Previous'}
              </Button>
              <Button
                onClick={onClickNextBuild}
                disabled={currentBuildIdPosition === buildIds.length - 1}
              >
                {'Next'}
              </Button>
            </ButtonToolbar>
          </div>
        )}
      </div>
      <BuildPathAndStatus buildId={currentBuildId} />
    </div>
  )
}

export default memo<Props>(ArtifactChangeDetailsPopupHeader)
